import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ConciergeContainer from "./ConciergeContainer";

const queryClient = new QueryClient();

export const ConciergeWithReactQuery: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConciergeContainer />
    </QueryClientProvider>
  );
};

const Concierge = () => {
  return (
    <div style={{ width: "100%" }}>
      <ConciergeWithReactQuery />
    </div>
  );
};

export default Concierge;
